<template>
  <div class="guaDdetails" v-if="routeClass == 3">
    <div class="crumbs">
      <crumbs>
        <el-button
          type="danger"
          size="small"
          v-if="
            info.product_id == '1001370' ||
              info.product_id == '1001371' ||
              info.product_id == '1001380' ||
              info.product_id == '1001379'
          "
          :disabled="info.status != 5"
          @click="cancelPOrder"
        >
          退保
        </el-button>
        <el-button
          type="primary"
          size="small"
          v-if="info.status == 4"
          @click="reInput"
        >
          重新录单
        </el-button>
        <el-button
          type="primary"
          size="small"
          :disabled="info.isChange != 1"
          @click="applyCheck"
        >
          申请批改
        </el-button>
        <el-button
          size="small"
          :disabled="
            !(
              info.is_have_bill == 1 &&
              (info.status == 3 ||
                info.status == 5 ||
                info.status == 6 ||
                info.status == 7)
            )
          "
          @click="getBillFile"
        >
          发票下载
        </el-button>
        <el-button
          size="small"
          @click="getPolicyFile"
          :disabled="
            !(
              info.status == 3 ||
              info.status == 5 ||
              info.status == 6 ||
              info.status == 7
            )
          "
          >电子保单下载
        </el-button>
      </crumbs>
    </div>
    <div class="guarantee" v-if="info">
      <div class="guerLeft">
        <div class="guerImgBox">
          <img :src="status[info.status].url" alt="" />
          <div>
            <i class="iconfont" :class="status[info.status].icon"></i>
            {{ info.statusTxt }}
          </div>
        </div>
      </div>
      <div class="guerRight">
        <div class="guerRightTop">
          <p>保单号：{{ info.policyNum ? info.policyNum : "暂无" }}</p>
          <p class="premium">
            保费：<span>{{ info.policyMoney }}</span>
          </p>
        </div>
        <div class="guerRightMiddle">
          <p>流水号：{{ info.numId ? info.numId : "暂无" }}</p>
          <p>保险公司：{{ info.companyName }}</p>
          <p>提交时间：{{ info.cTime }}</p>
          <p>产品名称：{{ info.plan.productName }}</p>
          <p>保障期限：{{ info.sTime }} - {{ info.eTime }}</p>
          <p>提交人：{{ info.adminName }}</p>
        </div>
        <div class="guerRightBottom">
          <p>方案详情：</p>
          <span>职业类别：{{ info.workCate }}</span>
          <span>{{ info.plan.death_quota }}</span>
          <span>{{ info.plan.medical_quota }}</span>
          <span
            v-if="
              info.product_id != '1001370' &&
                info.product_id != '1001371' &&
                info.product_id != '1001380' &&
                info.product_id != '1001379'
            "
            >{{ info.plan.loss_work_cost }}</span
          >
          <span>{{ info.plan.hospital_allowance }}</span>
          <span
            v-if="
              info.product_id != '1001370' &&
                info.product_id != '1001371' &&
                info.product_id != '1001380' &&
                info.product_id != '1001379'
            "
            >{{ info.plan.legal_fees }}</span
          >
          <span
            v-if="
              info.product_id != '1001370' &&
                info.product_id != '1001371' &&
                info.product_id != '1001380' &&
                info.product_id != '1001379'
            "
          >
            扩展信息：{{ info.plan.disabRatio }}{{ info.plan.isAllDays }}
          </span>
        </div>
      </div>
    </div>
    <div class="contentBox">
      <div class="itemBox">
        <div class="bTit" @click="step1 ? (step1 = false) : (step1 = true)">
          投保人信息
          <template v-if="insured">
            <span
              v-show="!step1"
              style="margin-left:15px;font-weight: 400;font-size:12px;"
            >
              企业名称：{{ insured.application.name }}
            </span>
            <span
              style="font-size:12px;font-weight: 400;color: rgba(0,0,0,0.5)"
              v-if="insured.application.code == insured.insure.code"
            >
              (被保企业同投保企业)
            </span>
          </template>
          <span v-if="step1" class="btn">
            <img src="@/assets/images/product/twotoplan.svg" alt="" />
          </span>
          <span v-else class="btn">
            <img src="@/assets/images/product/twobottomlan.svg" alt="" />
          </span>
        </div>
        <div class="conBox" v-show="step1">
          <div class="conBoxFlex" v-if="insured">
            <div class="left">
              <p>企业名称：{{ insured.application.name }}</p>
              <p>社会信用代码：{{ insured.application.code }}</p>
              <p>联系人：{{ insured.application.legal_person }}</p>
              <p>联系方式：{{ insured.application.phone }}</p>
              <p>
                地址：{{ insured.application.provinceName }}
                {{ insured.application.cityName }}
                {{ insured.application.areaName }}
                {{ insured.application.address }}
              </p>
              <p>施工地点：{{ insured.application.shigongdidian }}</p>
            </div>
            <div class="right">
              <span>营业执照：</span>
              <el-image
                :src="insured.application.code_img"
                :preview-src-list="[insured.application.code_img]"
              >
              </el-image>
            </div>
          </div>
          <div class="conBoxFlex" v-if="carInsured">
            <div class="left">
              <p>名称：{{ carInsured.application.name }}</p>
              <p>证件号：{{ carInsured.application.code }}</p>
              <p>联系人：{{ carInsured.application.legal_person }}</p>
              <p>联系方式：{{ carInsured.application.phone }}</p>
              <p>
                地址：{{ carInsured.application.provinceName }}
                {{ carInsured.application.cityName }}
                {{ carInsured.application.areaName }}
                {{ carInsured.application.address }}
              </p>
              <p v-if="carInsured.application.affiliation_agreement">
                挂靠协议：<span
                  @click="down(carInsured.application.affiliation_agreement)"
                  style="cursor: pointer;color: red;"
                >
                  文件
                </span>
              </p>
            </div>
            <div class="right">
              <span>证件照片：</span>
              <el-image
                :src="carInsured.application.codeImg[0]"
                :preview-src-list="carInsured.application.codeImg"
              >
              </el-image>
            </div>
          </div>
        </div>
      </div>

      <template v-if="insured">
        <div
          class="itemBox"
          v-if="insured.application.code != insured.insure.code"
        >
          <div class="bTit" @click="step2 ? (step2 = false) : (step2 = true)">
            被保人信息
            <span
              v-show="!step2"
              style="margin-left:15px;font-weight: 400;font-size:12px;"
            >
              企业名称：{{ insured.insure.name }}
            </span>
            <span v-if="step2" class="btn">
              <img src="@/assets/images/product/twotoplan.svg" alt="" />
            </span>
            <span v-else class="btn">
              <img src="@/assets/images/product/twobottomlan.svg" alt="" />
            </span>
          </div>
          <div class="conBox" v-show="step2">
            <div class="conBoxFlex" v-if="insured">
              <div class="left">
                <p>企业名称：{{ insured.insure.name }}</p>
                <p>社会信用代码：{{ insured.insure.code }}</p>
                <p>联系人：{{ insured.insure.legal_person }}</p>
                <p>联系方式：{{ insured.insure.phone }}</p>
                <p>
                  地址：{{ insured.insure.provinceName }}
                  {{ insured.insure.cityName }} {{ insured.insure.areaName }}
                  {{ insured.insure.address }}
                </p>
              </div>
              <div class="right">
                <span>营业执照：</span>
                <el-image
                  :src="insured.insure.code_img"
                  :preview-src-list="[insured.insure.code_img]"
                >
                </el-image>
              </div>
            </div>
          </div>
        </div>
      </template>
      <div class="itemBox">
        <div class="bTit" @click="step3 ? (step3 = false) : (step3 = true)">
          开票信息
          <span v-if="step3" class="btn">
            <img src="@/assets/images/product/twotoplan.svg" alt="" />
          </span>
          <span v-else class="btn">
            <img src="@/assets/images/product/twobottomlan.svg" alt="" />
          </span>
        </div>
        <div class="conBox" v-show="step3">
          <div class="conBoxFlex" v-if="invoice">
            <div class="left">
              <p v-if="!invoice.taxpayer_id">
                是否需要开票：<span class="textRed">
                  {{ invoice.taxpayer_id ? "" : "否" }}
                </span>
              </p>
              <template v-else>
                <p>
                  发票类型：{{
                    invoice.type == 1 ? "增值税普通发票" : "增值税专用发票"
                  }}
                </p>
                <p>纳税人名称：{{ invoice.taxpayer_name }}</p>
                <p>纳税人识别号：{{ invoice.taxpayer_id }}</p>
                <template v-if="invoice.type != 1">
                  <p>税务登记地址：{{ invoice.taxpayer_addr }}</p>
                  <p>税务登记联系电话：{{ invoice.taxpayer_tel }}</p>
                  <p>税务开户银行名称：{{ invoice.taxpayer_bank }}</p>
                  <p>税务开户银行账号：{{ invoice.taxpayer_bankno }}</p>
                  <p>
                    收件人：{{ invoice.new_contact_name }}； 联系电话：
                    {{ invoice.invoice_phone }}； 收件地址：
                    {{ invoice.address }}；
                  </p>
                </template>
              </template>
            </div>
            <div class="right" v-if="invoice.type == 2">
              <span>一般纳税人证明：</span>
              <el-image
                :src="invoice.ext_info"
                :preview-src-list="[invoice.ext_info]"
              >
              </el-image>
            </div>
          </div>
        </div>
      </div>
      <div class="itemBox" v-if="info.status != 8">
        <template v-if="pType != 3">
          <div class="bTit">人员清单</div>
          <div class="conBox">
            <div class="tabsTit">
              <p @click="personnelClick(1)">
                <img
                  :src="
                    type == 1
                      ? require('@/assets/images/product/capsule_left_a.png')
                      : require('@/assets/images/product/capsule_left.png')
                  "
                />
                <span :class="type == 1 ? 'active' : ''">在保人员 </span>
              </p>
              <p @click="personnelClick(2)">
                <img
                  :src="
                    type == 2
                      ? require('@/assets/images/product/capsule_center_a.png')
                      : require('@/assets/images/product/capsule_center.png')
                  "
                />
                <span :class="type == 2 ? 'active' : ''"> 过保人员 </span>
              </p>
              <p @click="personnelClick(3)">
                <img
                  :src="
                    type == 3
                      ? require('@/assets/images/product/capsule_left_a.png')
                      : require('@/assets/images/product/capsule_left.png')
                  "
                />
                <span :class="type == 3 ? 'active' : ''">待生效人员</span>
              </p>
              <div class="searchBox">
                <el-input
                  v-model.trim="searchData"
                  size="small"
                  placeholder="请输入姓名、身份证号"
                >
                </el-input>
                <el-button @click="searchBtn" size="small">搜索</el-button>
                <el-button @click="reset" size="small">重置</el-button>
                <export-excel
                  id="exportTab"
                  name="人员清单"
                  size="small"
                  icon="el-icon-download"
                  text="导出人员清单"
                ></export-excel>
              </div>
            </div>

            <el-table
              :data="tableData"
              border
              stripe
              style="width: 100%"
              size="mini"
              id="exportTab"
            >
              <el-table-column type="index" label="序号" width="80">
              </el-table-column>
              <el-table-column prop="name" label="姓名" min-width="90">
              </el-table-column>
              <el-table-column prop="code" label="身份证号" min-width="190">
              </el-table-column>
              <el-table-column
                prop="work_cate_title"
                label="工作类型"
                min-width="100"
              >
              </el-table-column>
              <el-table-column prop="money" label="保费金额" min-width="120">
              </el-table-column>
              <el-table-column
                prop="work_type_title"
                label="工种"
                show-overflow-tooltip
                min-width="200"
              >
              </el-table-column>
              <el-table-column label="保障期限" min-width="360">
                <template slot-scope="scope">
                  {{ scope.row.s_time }} -- {{ scope.row.e_time }}
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              @size-change="sizeChange"
              @current-change="currentChange"
              :page-sizes="pageSizeArray"
              :page-size.sync="pageSize"
              :current-page.sync="page"
              :total="total"
              background
              layout="total, sizes, prev, pager, next, jumper"
            >
            </el-pagination>
          </div>
        </template>
        <!-- 车险清单 -->
        <template v-else>
          <div class="bTit">车辆清单</div>

          <div class="conBox">
            <el-table
              :data="carInsured.carList"
              border
              stripe
              style="width: 100%"
              size="mini"
              id="exportTab"
            >
              <el-table-column type="index" label="序号" width="80">
              </el-table-column>
              <el-table-column prop="carNum" label="车牌号" min-width="90">
              </el-table-column>
              <el-table-column prop="carCode" label="车辆识别">
              </el-table-column>
              <el-table-column prop="engineNumber" label="发动机号">
              </el-table-column>
              <el-table-column
                prop="drivingLicenseFrontPage"
                label="行驶证正页"
                width="150"
              >
                <template slot-scope="scope">
                  <el-image
                    :src="scope.row.drivingLicenseFrontPage"
                    :preview-src-list="[scope.row.drivingLicenseFrontPage]"
                    style="width: 50px;height: 50px;"
                  >
                  </el-image>
                </template>
              </el-table-column>
              <el-table-column
                prop="drivingLicenseSubPage"
                label="行驶证副页"
                width="150"
              >
                <template slot-scope="scope">
                  <el-image
                    style="width: 50px;height: 50px;"
                    :src="scope.row.drivingLicenseSubPage"
                    :preview-src-list="[scope.row.drivingLicenseSubPage]"
                  >
                  </el-image>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </template>
      </div>

      <div class="itemBox">
        <div class="bTit">其他投保文件</div>
        <div class="conBox">
          <p class="fileDown">
            <span @click="down(info.insureFile)" v-if="info.insureFile">
              文件
            </span>
          </p>
        </div>
      </div>
    </div>
    <div class="logBox">
      <div class="logTit"><i class="el-icon-tickets"></i> 操作日志</div>
      <div class="logCon">
        <span class="btn" @click="logState = true" v-if="!logState">
          展开 <i class="el-icon-arrow-down"></i>
        </span>
        <span class="btn" @click="logState = false" v-else>
          收起 <i class="el-icon-arrow-up"></i>
        </span>
        <template v-for="(item, index) in Log">
          <p :key="index" :class="logState ? '' : 'show'">
            {{ item.createtime }}
            <span>{{ item.username }}</span>
            <span>{{ item.title }}</span>
          </p>
        </template>
      </div>
    </div>
  </div>
  <router-view v-else />
</template>
<script>
import {
  getOrderInfo,
  getOrderInsured,
  getCarOrderInsured,
  getOrderInvoice,
  getOrderPersonnel,
  getOperationLog,
  cancelPOrder
} from "@/api/guarantee";
import { getBillFile, getPolicyFile } from "@/api/public";
import download from "@/utils/download";
import crumbs from "@/components/common/crumbs";
import exportExcel from "@/components/common/exportExcel";
export default {
  name: "guaDdetails",
  components: {
    crumbs,
    exportExcel
  },
  data() {
    return {
      routeClass: "",
      status: {},
      numId: "",
      pType: "", //产品类型
      info: "", //订单详情
      insured: "", //投、被保人
      carInsured: "", //车险投保信息
      invoice: "", //开票信息
      tableData: [], //人员清单
      oldTableData: [], //人员清单原始数据
      searchData: "", //人员清单搜索
      // 分页 每页条数
      pageSize: 15,
      // 分页 每页条数可选项
      pageSizeArray: [15, 30, 45, 60, 100],
      // 当前页
      page: 1,
      // 总页数
      total: 0,
      Log: [],
      logState: false,
      type: "1", //保障状态：1 在保 2 过保 3 待生效
      step1: false, //收起
      step2: false, //收起
      step3: false //收起
    };
  },
  created() {
    // 获取当前路由等级
    this.routeClass = this.$route.matched.length;
    this.status = this.$store.state.orderStatus;
    this.numId = this.$route.query.numId;
    this.pType = this.$route.query.type;
    this.getOrderInfo(); //获取订单详情
    // this.getOrderInsured(); //获取投、被保人
    this.getOrderInvoice(); //开票信息
    this.getOrderPersonnel(); //保障人员
    this.getOperationLog(); //操作记录接口
    console.log(this.pType);
    if (this.pType == 3) {
      this.getCarOrderInsured();
    } else {
      this.getOrderInsured(); //获取投、被保人
    }
  },
  methods: {
    //获取订单详情
    getOrderInfo() {
      let that = this;
      getOrderInfo({ numId: this.numId })
        .then(function(res) {
          console.log(res);
          if (res.code == 1) {
            that.info = res.data;
            // 设置title
            document.title = "保单详情--" + res.data.applicationName;
          } else {
            that.$message.error(res.msg);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    }, //获取投、被保人
    getOrderInsured() {
      let that = this;
      getOrderInsured({ numId: this.numId })
        .then(function(res) {
          console.log(res);
          if (res.code == 1) {
            that.insured = res.data;
          } else {
            that.$message.error(res.msg);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    //车辆投保时获取投信息
    getCarOrderInsured() {
      let that = this;
      getCarOrderInsured({ numId: this.numId })
        .then(function(res) {
          console.log(res);
          if (res.code == 1) {
            that.carInsured = res.data;
          } else {
            that.$message.error(res.msg);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    }, //获取开票信息
    getOrderInvoice() {
      let that = this;
      getOrderInvoice({ numId: this.numId })
        .then(function(res) {
          console.log(res);
          if (res.code == 1) {
            that.invoice = res.data;
          } else {
            that.$message.error(res.msg);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    }, //获取保障人员
    getOrderPersonnel() {
      let that = this;
      getOrderPersonnel({ numId: this.numId, type: this.type })
        .then(function(res) {
          console.log(res);
          if (res.code == 1) {
            that.oldTableData = res.data;
            that.paging();
          } else {
            that.$message.error(res.msg);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    // 操作记录
    getOperationLog() {
      let that = this;
      getOperationLog({ numId: this.numId })
        .then(function(res) {
          console.log(res);
          if (res.code == 1) {
            that.Log = res.data;
          } else {
            that.$message.error(res.msg);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    // 人员类型切换
    personnelClick(e) {
      this.type = e;
      this.getOrderPersonnel();
    },
    // 驳回状态重新录入
    reInput() {
      // 页面跳转
      let _url = this.$router.resolve({
        path: "/insure/fillIn",
        query: { id: this.info.product_id, type: this.pType, numId: this.numId }
      });
      window.open(_url.href, "_blank");
    },
    // 美亚的退保功能
    cancelPOrder() {
      let that = this;
      this.$confirm("此操作不可恢复, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        cancelPOrder({ numId: this.numId })
          .then(function(res) {
            console.log(res);
            if (res.code == 1) {
              that.$message.success(res.msg);
              that.$router.push({
                path: "/guarantee"
              });
            } else {
              that.$message.error(res.msg);
            }
          })
          .catch(function(error) {
            console.log(error);
          });
      });
    },
    // 下载
    down(downurl) {
      download(downurl);
    },
    //申请开发票，下载发票
    getBillFile() {
      let that = this;
      let loadind = that.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      getBillFile({ numId: this.numId })
        .then(function(res) {
          loadind.close();
          console.log(res);
          if (res.code == 1) {
            if (res.data) {
              that.down(res.data.billUrl);
            } else {
              that.$message.success(res.msg);
            }
          } else {
            that.$message.error(res.msg);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    //申请保单，下载保单
    getPolicyFile() {
      let that = this;
      let loadind = that.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      getPolicyFile({ numId: this.numId })
        .then(function(res) {
          loadind.close();
          console.log(res);
          if (res.code == 1) {
            if (res.data) {
              that.down(res.data.policyUrl);
            } else {
              that.$message.success(res.msg);
            }
          } else {
            that.$message.error(res.msg);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    // 申请批改
    applyCheck() {
      this.$router.push({
        path: "/guarantee/check",
        query: { numId: this.numId }
      });
    },
    // 搜索人员清单
    searchBtn() {
      this.paging();
    },
    // 重置人员清单
    reset() {
      this.searchData = "";
      this.paging();
    },
    // 每页几条
    sizeChange() {
      this.paging();
    },
    // 页码变化
    currentChange() {
      this.paging();
    },
    //分页处理
    paging() {
      let that = this;
      let _data = [];
      if (that.searchData != "") {
        that.page = 1;
        _data = that.oldTableData.filter(function(item) {
          return (
            item.name.includes(that.searchData) ||
            item.code.includes(that.searchData)
          );
        });
      } else {
        _data = that.oldTableData.filter(function(item) {
          return item;
        });
      }
      let _start = that.pageSize * (that.page - 1);
      let _end = that.pageSize * that.page;
      that.tableData = _data.slice(_start, _end);
      that.total = _data.length;
    }
  }
};
</script>
<style lang="scss">
.guaDdetails {
  padding: 0 !important;
  margin-top: 15px !important;
  background: #f4f5f7 !important;
  box-shadow: none !important;
  & > .crumbs {
    margin: 0 8px;
  }
  .guarantee {
    padding: 24px 40px 40px 24px;
    background: #ffffff
      linear-gradient(
        150deg,
        #ffffff 0%,
        rgba(245, 248, 251, 0.76) 100%,
        #64dfff 100%
      );
    box-shadow: 0px 2px 4px 0px rgba(4, 46, 111, 0.11);
    border-radius: 9px 10px 5px 5px;
    margin: 15px 0;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    overflow: hidden;
    .guerLeft {
      width: 72px;
      height: 72px;
      margin-right: 30px;
      .guerImgBox {
        position: relative;
        top: -24px;
        height: 100%;
        img {
          position: absolute;
          top: -15px;
          left: -16px;
        }
        & > div {
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          color: #fff;
          font-size: 14px;
          font-weight: 500;
          i {
            font-size: 25px;
            font-weight: 400;
            margin-top: 15px;
          }
        }
      }
    }
    .guerRight {
      width: calc(100% - 87px);
      .guerRightTop {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 20px;
        font-weight: 500;
        color: #000000;
        line-height: 28px;
        margin-bottom: 20px;
        p {
          margin: 0;
        }
        .premium {
          font-size: 14px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #000000;
          line-height: 20px;
          span {
            font-size: 24px;
            color: #f76a37;
          }
        }
      }
      .guerRightMiddle {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-wrap: wrap;
        & > p {
          width: 33.33%;
          font-size: 14px;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.85);
          line-height: 22px;
          margin: 0;
        }
      }
      .guerRightBottom {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-top: 30px;
        p {
          margin: 0;
          font-size: 14px;
          font-weight: 500;
          color: rgba(255, 255, 255, 0.85);
          border-radius: 15px 0px 15px 0px;
          background: #2d8aee;
          padding: 2px 12px;
          margin-right: 20px;
        }
        span {
          font-weight: 400;
          color: rgba(0, 0, 0, 0.85);
          font-size: 14px;
        }
        span + span {
          margin-left: 20px;
        }
      }
    }
  }
  & > .contentBox {
    background: #ffffff;
    box-shadow: 0px 2px 4px 0px rgba(4, 46, 111, 0.08);
    & > .itemBox + .itemBox {
      border-top: 1px solid #eee;
    }
    & > .itemBox {
      .bTit {
        font-size: 16px;
        font-weight: 500;
        color: rgba(0, 0, 0, 0.85);
        line-height: 22px;
        padding: 15px 20px;
        position: relative;
        cursor: pointer;
        .btn {
          position: absolute;
          top: 15px;
          right: 15px;
          z-index: 2;
        }
      }
      .bTit:before {
        content: "";
        display: inline-block;
        width: 4px;
        height: 24px;
        background: #2d8aee;
        border-radius: 0px 10px 10px 0px;
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
      }
      .conBox {
        padding: 5px 100px 20px 85px;
        .conBoxFlex {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          p {
            margin: 0;
            color: #333;
            font-size: 14px;
            font-weight: 400;
            color: #000000;
            line-height: 40px;
          }
          .left {
            min-width: 550px;
            margin-right: 20px;
          }
          .right {
            display: flex;
            align-items: center;
            justify-content: flex-start;
            span {
              font-size: 14px;
              font-weight: 400;
              color: #000000;
              line-height: 20px;
            }
            .el-image {
              width: 200px;
              height: 200px;
            }
          }
        }
        .tabsTit {
          display: inline-flex;
          justify-items: flex-start;
          align-items: center;
          // border-radius: 16px;
          background: #fff;
          overflow: hidden;
          margin-bottom: 20px;
          p {
            font-size: 14px;
            font-weight: 400;
            color: rgba(0, 0, 0, 0.85);
            margin: 0;
            position: relative;
            width: 116px;
            cursor: pointer;
            img {
              width: 100%;
              height: 32px;
              vertical-align: middle;
            }
            span {
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
              width: 100%;
              text-align: center;
              line-height: 1;
            }
            span.active {
              color: rgba(255, 255, 255, 0.85);
            }
          }
          p + p {
            margin-left: -10px;
          }
          p:nth-child(3) img {
            transform: rotate(180deg);
          }
          div.searchBox {
            margin-left: 50px;
            .el-input {
              width: 200px;
              margin-right: 25px;
            }
            .el-input + .el-button {
              border-color: #2d8aee;
              color: #2d8aee;
            }
          }
        }
        .el-table {
          th {
            background: #f1f4f8;
          }
          .cell {
            padding-left: 20px;
            padding-right: 20px;
            line-height: 27px;
            font-size: 14px;
            font-weight: 400;
            color: rgba(0, 0, 0, 0.85);
          }
        }
        .textRed {
          color: rgba(255, 0, 0, 0.85);
        }
        .fileDown {
          cursor: pointer;
        }
        .fileDown:hover {
          color: #409eff;
        }
      }
    }
  }
  & > .logBox {
    background: #ffffff;
    box-shadow: 0px 2px 4px 0px rgba(4, 46, 111, 0.08);
    opacity: 0.89;
    margin-top: 15px;
    overflow: hidden;
    .logTit {
      padding: 25px 35px 0;
      font-size: 16px;
      font-weight: 400;
      color: #000000;
      line-height: 22px;
      i {
        color: #2d8aee;
        margin-right: 8px;
        font-weight: 600;
      }
    }
    .logCon {
      margin: 30px 100px 40px 85px;
      background: #f0f3f7;
      padding: 15px 15px;
      position: relative;
      .btn {
        position: absolute;
        top: 15px;
        right: 15px;
        cursor: pointer;
        z-index: 2;
      }
      p {
        font-size: 14px;
        font-weight: 500;
        color: rgba(0, 0, 0, 0.85);
        line-height: 20px;
        margin: 0;
        position: relative;
        span {
          font-size: 14px;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.65);
          display: inline-block;
        }
        span:first-child {
          min-width: 100px;
          margin-left: 35px;
        }
      }
      p:before {
        content: "";
        display: inline-block;
        width: 14px;
        height: 14px;
        background: #f0f3f7;
        border: 2px solid #2d8aee;
        border-radius: 50%;
        margin-right: 20px;
        vertical-align: middle;
      }
      p + p {
        padding-top: 24px;
      }
      p + p::after {
        content: "";
        display: inline-block;
        width: 1px;
        height: 30px;
        position: absolute;
        background: #97979775;
        top: -2px;
        left: 7px;
      }
      p.show + .show {
        display: none;
      }
    }
  }
}
</style>
